/** Reference links for tides outside US NOAA (charts / forecasts). */

export interface GlobalTideRef {
  name: string;
  lat: number;
  lng: number;
  url: string;
  region: string;
}

export const GLOBAL_TIDE_REFS: GlobalTideRef[] = [
  {
    region: 'UK',
    name: 'Plymouth',
    lat: 50.37,
    lng: -4.14,
    url: 'https://www.tide-forecast.com/locations/Plymouth-England/tides/latest',
  },
  {
    region: 'UK',
    name: 'Liverpool',
    lat: 53.41,
    lng: -3.0,
    url: 'https://www.tide-forecast.com/locations/Liverpool-England/tides/latest',
  },
  {
    region: 'France',
    name: 'Brest',
    lat: 48.38,
    lng: -4.49,
    url: 'https://www.tide-forecast.com/locations/Brest-France/tides/latest',
  },
  {
    region: 'Portugal',
    name: 'Lisbon',
    lat: 38.72,
    lng: -9.14,
    url: 'https://www.tide-forecast.com/locations/Lisbon-Portugal/tides/latest',
  },
  {
    region: 'Japan',
    name: 'Tokyo Bay',
    lat: 35.45,
    lng: 139.75,
    url: 'https://www.tide-forecast.com/locations/Tokyo-Japan/tides/latest',
  },
  {
    region: 'Australia',
    name: 'Sydney',
    lat: -33.86,
    lng: 151.21,
    url: 'https://www.tide-forecast.com/locations/Sydney-Australia/tides/latest',
  },
  {
    region: 'NZ',
    name: 'Wellington',
    lat: -41.29,
    lng: 174.78,
    url: 'https://www.tide-forecast.com/locations/Wellington-New-Zealand/tides/latest',
  },
  {
    region: 'Brazil',
    name: 'Rio de Janeiro',
    lat: -22.91,
    lng: -43.17,
    url: 'https://www.tide-forecast.com/locations/Rio-de-Janeiro-Brazil/tides/latest',
  },
  {
    region: 'Canada',
    name: 'Vancouver',
    lat: 49.28,
    lng: -123.12,
    url: 'https://www.tide-forecast.com/locations/Vancouver-British-Columbia/tides/latest',
  },
  {
    region: 'South Africa',
    name: 'Cape Town',
    lat: -33.91,
    lng: 18.42,
    url: 'https://www.tide-forecast.com/locations/Cape-Town-South-Africa/tides/latest',
  },
];
